import React from 'react';
import store from "../store";
import {Link} from "react-router";
import langs from "./langs/phpIndex";

import {API_VERSION} from "./baseFunctions";

class Right extends React.Component {
	constructor()
	{
		super();
		this.a = this.a.bind(this);
	}
	componentDidMount(){
		window.window.$BODY = window.$("body"),
    window.$MENU_TOGGLE = window.$("#menu_toggle"),
    window.$SIDEBAR_MENU = window.$("#sidebar-menu"),
    window.$SIDEBAR_FOOTER = window.$(".sidebar-footer"),
    window.$LEFT_COL = window.$(".left_col"),
    window.$RIGHT_COL = window.$(".right_col"),
    window.$NAV_MENU = window.$(".nav_menu"),
    window.$FOOTER = window.$("footer");
    var me = this;
    window.$SIDEBAR_MENU.find("a").on("click", function(b) {
        var c = window.$(this).parent();
        c.is(".active") ? (c.removeClass("active active-sm"),
        window.$("ul:first", c).slideUp(function() {
            me.a()
        })) : (c.parent().is(".child_menu") ? window.$BODY.is(".nav-sm") && (window.$SIDEBAR_MENU.find("li").removeClass("active active-sm"),
        window.$SIDEBAR_MENU.find("li ul").slideUp()) : (window.$SIDEBAR_MENU.find("li").removeClass("active active-sm"),
        window.$SIDEBAR_MENU.find("li ul").slideUp()),
        /*window.$("ul.child_menu li.active").removeClass("active"),
        c.addClass("active"),*/
        window.$("ul:first", c).slideDown(function() {
            me.a()
        }))
    })
	}
	a(){
    window.$RIGHT_COL.css("min-height", window.$(window).height());
    var a = window.$BODY.outerHeight(),
        b = window.$BODY.hasClass("footer_fixed") ? -10 : window.$FOOTER.height(),
        c = window.$LEFT_COL.eq(1).height() + window.$SIDEBAR_FOOTER.height(),
        d = a < c ? c : a;
    d -= window.$NAV_MENU.height() + b, window.$RIGHT_COL.css("min-height", d);
	}
	
	render(){
		const style = this.props.noHeight ? {"overflow": "auto"} : {"overflow": "auto", minHeight: "100vh"};
		if(this.props.onlyContent)
		{
			return (<div className="right_col" role="main" style={{...style, marginLeft: "0px"}}>
	    	<div>
	    	{
	    		this.props.title ? 
	    		<div className="page-title">
	          <div className="title_left">
	              <h3>{this.props.title}</h3>
	          </div>
	  			</div>: ""
	    	}
					
	  		</div>
	   	 {this.props.children}
	   </div>);
		}
		let name = false;
		let temp = false;
		if(this.props.token)
		{
			temp = JSON.parse(atob(this.props.token.split(".")[1]));
			name = temp.name;
		}
		const LANG = langs[this.props.lang ? this.props.lang : "DK"];
		return (
			<div> 
				<div className="top_nav">
		      <div className="nav_menu" style={{marginBottom: "0px"}}>
		        <nav>
		          <div className="nav toggle">
		            <a id="menu_toggle" onClick={() => {
		            	window.$BODY.hasClass("nav-md") ? (window.$SIDEBAR_MENU.find("li.active ul").hide(), window.$SIDEBAR_MENU.find("li.active").addClass("active-sm").removeClass("active")) : (window.$SIDEBAR_MENU.find("li.active-sm ul").show(), window.$SIDEBAR_MENU.find("li.active-sm").addClass("active").removeClass("active-sm")), window.$BODY.toggleClass("nav-md nav-sm"), this.a()
		            }}><i className="fa fa-bars"></i></a>
		          </div>
		          <ul className="nav navbar-nav navbar-right">
		            <li className="">
		            	{
		            		name ?
		                  <a href="javascript:;" className="user-profile dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
		                  	{
		                  		name
		                  	}
		                    <span className=" fa fa-angle-down" style={{paddingLeft: "5px"}}></span>
		                  </a>
		            		: null
		            	}
                  <ul className="dropdown-menu dropdown-usermenu pull-right">
                    <li>
                    	<Link to={temp ? "/users/edit/" + temp.id : "/users"}>
                    		{LANG.EDIT_USER}
                    	</Link>
                    </li>
                    <li><a href="" onClick={() => store.dispatch({
				          		type: "UPD_AUTH",
				          		data: 0
				          	})}>
                    		<i className="fa fa-sign-out pull-right"></i> {LANG.SIGN_OUT}
                    </a>
                    </li>
                    <li>
											<a>
											<small>
												version {API_VERSION}
											</small>
											</a>
                    </li>
                  </ul>
                </li>
		            <li className="" style={{display: "none"}}>
		              <a>
		                <select style={{padding: "8px"}}>
		                	<option>Afdeling 1</option>
		                	<option>-> Afdeling 2</option>
		                </select>
		              </a>
		            </li>
		            {
		            	this.props.extraPanel ? 
		            	<li className="">
			              {this.props.extraPanel()}
			            </li>
		            	: ""
		            }
		            
		          </ul>
		        </nav>
		      </div>
	    </div>

	    <div className="right_col" role="main" style={style}>
	    	<div>
	    	{
	    		this.props.title ? 
	    		<div className="page-title">
	          <div className="title_left">
	              <h3>{this.props.title}</h3>
	          </div>
	  			</div>: ""
	    	}
					
	  		</div>
	   	 {this.props.children}
	   </div>
    </div>);
	}
}

export default Right;


// WEBPACK FOOTER //
// ./src/components/Right.js